<template>
  <div class="main-container">
    <v-flex md3 xs4 style="padding: 8px">

      <choose-date clearable :label='$t("captainProfilePage.shiftLogs.filterByDay")' v-model="date_filter"></choose-date>
    </v-flex>

    <div style="overflow-x: auto; white-space: nowrap;">
      <table class="noselect">
        <tr>

          <th v-for="(_hour, index) in 24" :key="index">
            {{ index }}:00 - {{ index == 23 ? 0 : index + 1 }}:00
          </th>
        </tr>
        <tr>

          <td v-for="(_hour, index) in 24" :key="index">
            <span :style="getTextStyle(sortedShifts[index])">{{ sortedShifts[index] }} </span>
          </td>
        </tr>
      </table>
    </div>
    <v-dialog v-model="diaload" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t("captainProfilePage.common.loadingData") }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { companyNow } from "@/util/companyTime";
import axios from "axios";
import api from "@/constants/api";
import ChooseDate from "@/components/monaco/input/ChooseDate";

export default {
  name: "ShiftLogs",
  components: { ChooseDate },
  props: {
    captainId: {
      required: true,
    },
  },
  data: () => ({
    shifts: [],
    sortedShifts: [],
    date_filter: null,
    diaload: false,
  }),
  computed: {
    activeArray() {
      return [
        this.$t("captainProfilePage.shiftLogs.offline"),
        this.$t("captainProfilePage.shiftLogs.online"),
      ];
    },
  },
  watch: {

    date_filter() {
      this.filter();
    },
  },
  mounted() {
    this.date_filter = companyNow().format("YYYY-MM-DD")
  },
  methods: {
    filter() {
      this.diaload = true;
      const params = new URLSearchParams();
      params.append('captain_id', this.captainId);
      params.append('day', moment(this.date_filter).format("YYYY-MM-DD"));

      axios
        .get(this.api.ACTIONS.CAPTAIN_SHIFT_LOGS, { params })
        .then((res) => {

          this.shifts = res.data.data;
          for (let i = 0; i <= 23; i++) {
            this.sortedShifts[i] = this.getData(i);
          }
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("captainProfilePage.common.errorTryLater"),'red');
          console.log(err);
        })
        .finally(() => {
          this.diaload = false;
        });
    },
    getData(index) {
      let formattedDate = moment(`${moment(this.date_filter).format("YYYY-MM-DD")} ${index}:00:00`, 'YYYY-MM-DD H:m:s').format('YYYY-MM-DD HH:mm:ss');
      let res = this.shifts.find(a => a.from_datetime == formattedDate);

      return res ? this.activeArray[res.active] : "";
    },
    getTextStyle(content) {
      if (content == this.activeArray[0]) {
        return { color: "red" };
      } else {
        return { color: "green" };
      }
    },
  },


};
</script>

<style lang="scss" scoped>
.main-container {
  float: inline-start;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  padding: 18px 25px;
  gap: 20px;

  .statuses {
    width: auto;
    height: 42px;
    float: inline-start;
    display: flex;
    flex-direction: row;
    gap: 10px;

    .status {
      padding: 13px 18px;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      float: inline-start;
      color: white;
      border-radius: 9999px;
    }
  }



  table {
    width: 100%;
    height: auto;
    float: inline-start;
    background: white;
    padding: 0;
    border-radius: 10px;
    box-shadow: 0px 0px 6px rgba($color: #000b8a, $alpha: 0.1);
    // table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;

    td,
    th,
    tr {
      border: 1px solid #c1c5d8;
      height: 45px;
      // overflow: hidden;

      .current-time-indicator {
        top: 0;
        width: 2px;
        background: #e10015;
        height: 100%;
        position: absolute;
        z-index: 18;
      }
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 10px !important;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 10px !important;
    }

    tr:first-child th:last-child {
      border-top-right-radius: 10px !important;
    }

    tr:first-child th:first-child {
      border-top-left-radius: 10px !important;
    }

    tr:nth-child(even) {
      background-color: #f7f8fa;
    }

    td,
    th {
      padding: 14px;
      padding-inline-start: 16px;
    }

    .driver-name {
      width: 13%;
      max-width: 142px;
      min-width: 100px;
      padding: 16px;
      text-align: start;
    }

    .taxi-number {
      width: 10%;
      padding: 16px;
      max-width: 142px;
      text-align: start;
    }

    .timing-container {
      width: 100%;
      height: 100%;
      max-width: 100%;
      position: relative;
      overflow-x: overlay;

      .status {
        position: absolute;
        top: 50%;
        inset-inline-start: 0;
        transform: translateY(-50%);
        height: 12px;
        border-radius: 9999px;
        z-index: 8;
        cursor: pointer;
        transition: 0.2s;

        &.end {
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }
      }

      .times {
        width: max-content;
        height: 100%;
        position: absolute;
        top: 0;
        inset-inline-start: 0;

        .time {
          width: 184px;
          height: 100%;
          float: inline-start;
          padding: 16px 22px;
          text-align: start;
          position: relative;

          .half-hour-divider {
            height: 10px;
            width: 1px;
            background: #c1c5d8;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }

          &:not(:last-child) {
            border-inline-end: 1px solid #c1c5d8;
          }
        }
      }

      &::-webkit-scrollbar {
        width: 0em;
        height: 0em;
      }
    }

    .noOrders {
      p {
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>